import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-99565868"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "feature" }
const _hoisted_2 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" 私有化部署 vs SaaS版核心差异 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_table, {
        class: "table_box",
        rowClassName: (record, index) => (index % 2 === 0 ? 'table_striped' : 'table_column'),
        columns: $data.expand.columns,
        "data-source": $data.expand.data,
        bordered: "",
        pagination: false
      }, null, 8 /* PROPS */, ["rowClassName", "columns", "data-source"])
    ])
  ]))
}